import { render, staticRenderFns } from "./Servidor.vue?vue&type=template&id=66e0b479"
import script from "./Servidor.vue?vue&type=script&lang=js"
export * from "./Servidor.vue?vue&type=script&lang=js"
import style0 from "./Servidor.vue?vue&type=style&index=0&id=66e0b479&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports